//首页
const home = () => import('@/views/home');


const routes = [
    {
	    path: '/',
	    name: "home",
	    component: home,
	    meta: {
	        title: '四川大学高等教育成人教育'
	    }
	}
]
export default routes;